function trimTrailingSlash(value: string) {
    return value.endsWith('/') ? value.substring(0, value.length - 1) : value
}

export function apiNavigationBaseUrl() {
    const baseUrl = process.env.VUE_APP_BASE_URL_API_NAVIGATION || process.env.VUE_APP_BASE_URL_API || ''
    return trimTrailingSlash(baseUrl)
}
